<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-12">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Configurações Ferramentaria:
          <span>
            {{
              $route.name === "ferramentaria-configuracao-status"
                ? "Status"
                : $route.name === "ferramentaria-configuracao-operacao"
                ? "Operação"
                : $route.name === "ferramentaria-configuracao-checklist"
                ? "Checklist"
                : $route.name === "ferramentaria-configuracao-catalogo"
                ? "Catálogo"
                : $route.name === "ferramentaria-configuracao-deposito"
                ? "Depósito"
                : ""
            }}</span
          >
        </p>
      </div>
    </div>
    <div class="row col-12 q-mt-md">
      <div class="col-md-2 col-xs text-brand-5 text-weight-bold">
        <div class="texto-titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>
    </div>
    <div
      class="row col-12 q-mt-md q-gutter-sm items-center text-brand-5 text-weight-bold"
    >
      <router-link
        :to="{ name: 'ferramentaria-configuracao-status', params: { id: 0 } }"
      >
        <p></p>
        <q-btn
          :outline="$route.name != 'ferramentaria-configuracao-status'"
          color="positive"
          label="Status"
          no-caps
          class="q-mt-xs btn"
          icon="trending_up"
        />
      </router-link>
      <router-link
        :to="{ name: 'ferramentaria-configuracao-operacao', params: { id: 0 } }"
      >
        <p></p>
        <q-btn
          :outline="$route.name != 'ferramentaria-configuracao-operacao'"
          label="Operação"
          no-caps
          color="red"
          class="q-mt-xs btn"
          icon="import_contacts"
        />
      </router-link>
      <router-link
        :to="{
          name: 'ferramentaria-configuracao-checklist',
          params: { id: 0 },
        }"
      >
        <p></p>
        <q-btn
          :outline="$route.name != 'ferramentaria-configuracao-checklist'"
          label="Checklist"
          no-caps
          color="primary"
          class="q-mt-xs btn"
          icon="security"
        />
      </router-link>
      <router-link
        :to="{ name: 'ferramentaria-configuracao-catalogo', params: { id: 0 } }"
      >
        <p></p>
        <q-btn
          :outline="$route.name != 'ferramentaria-configuracao-catalogo'"
          label="Catálogo"
          no-caps
          color="secondary"
          class="q-mt-xs btn"
          icon="admin_panel_settings"
        />
      </router-link>
      <router-link
        :to="{ name: 'ferramentaria-configuracao-deposito', params: { id: 0 } }"
      >
        <p></p>
        <q-btn
          :outline="$route.name != 'ferramentaria-configuracao-deposito'"
          label="Depósito"
          no-caps
          color="black"
          class="q-mt-xs btn"
          icon="business"
        />
      </router-link>
    </div>
    <router-view></router-view>
  </q-page>
</template>

<script>
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  components: { ListaUnidadesSelect },
  setup() {
    return {};
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: black;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .btn {
    font-size: 12px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
}
@media (max-width: 372px) {
  .btn {
    font-size: 11px;
  }
}
</style>
